import React,{useEffect, useState,useContext, useRef,useCallback} from "react";
import Renderdevice from './rendergroup'
import "./../../register.css";
import {getEquipment,getGrouplist} from './../../services/fire';
import BranchContext from "../context/branch";
import Select from "../common/selectcustom";
import Input from "../common/inputfunction";
import FontAwesome from 'react-fontawesome';
import ModalAddItem from './addgroup'
import Header from "./header";
// import HeaderGroup from "./headergroupdevice";
import ScrollToTop from "../common/ScrollToTop";
import ProgressBar from '../common/progressbar';

const Itemlist = (props) => {


  const { currentBranch } = useContext(BranchContext);
  const [edit,setEdit] = useState(false);
  const [search, setsearch] = useState('');
   const [name, setname] = useState('');
   const [lastupdate, setlastupdate] = useState(new Date());
  const [groupid, setgroupid] = useState(0);
  const [siteid, setsiteid] = useState(0);
  const [buid, setbuid] = useState(0);
  const [areaid, setareaid] = useState(0);
  const [id, setid] = useState(0);
  const [disable, setdisable] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false)
  const [pageSize,setPageSize] = useState(30);
  const [total,setTotal] = useState(0);
  const [devicelist, setsdevicelist] = useState([]);
  const [grouplist, setgrouplist] = useState([]);
  const [bulist, setbulist] = useState([]);
  const [arealist, setarealist] = useState([]);
  const [isOpen, setisOpen] = useState(false);
  const [data, setdata] = useState([]);
  const [messageerror, setmessageerror] = useState("");
  
  const [header, setheader] = useState("");
  const [showonscroll, setshowonscroll] = useState(false)
  const [showprogress, setshowprogress] = useState(false)
  
  const [completed, setcompleted] = useState(50)
  const [values ,setvalues] =useState({face_id:0,facename:''});


  // useEffect(() => {
   
  //   const loadDta= async () => {

  //     const { data: result } = await getEquipment();
  //     if (result.status === "success") {
  //       setgrouplist(result.data.list); 
  //     }else if (result.status === "error"){
       
  //     }
  //   };
  //   loadDta(); 
  // }, []);

  useEffect(() => {
  
    setsdevicelist([]);
  }, [currentBranch, pageSize,search,lastupdate,showonscroll,disable]);

    useEffect(() => {
        if (!currentBranch) return;
     
        if (!pageSize || !pageNumber  ) return;
        setLoading(true)
        setError(false)
        setshowprogress(true)
            const loadData = async () => {
 
                const { data: result } = await getGrouplist(search,pageSize,pageNumber,disable);
                if ( result.status==='success') {
                 // console.log(result)
                    setTotal(result.data.total);
                    setshowprogress(false)
                    setsdevicelist(prevData => {   
             return [...new Set([...prevData, ...result.data.list])]
                          })
                   setHasMore(result.data.list.length > pageSize-1)
                   setLoading(false)                 
                }else if(result.status === "error" && result.message === "invalid token"){
                  const urlGoBack = "logout";
                  setTimeout(props.history.replace(urlGoBack), 1000);
                }
        };
        loadData();
      }         
      , [currentBranch,search,pageSize,pageNumber,lastupdate,showonscroll,disable]);

      const observer = useRef();
      const lastBookElementRef = useCallback(
        (node) => {

          if (node && node.offsetTop > 0){
            setshowonscroll(true);
           }
       
          if (loading) return;
          if (observer.current) observer.current.disconnect();
          observer.current = new IntersectionObserver((entries) => {
            
    
            if (entries[0].isIntersecting && hasMore) {
              setPageNumber((prevPageNumber) => prevPageNumber + 1);
            }
          });
          if (node) observer.current.observe(node);
        },
        [loading, hasMore]
      );
        
 
// const handleChangeAreaId = (event) => {
//   setareaid(event.currentTarget.value);
//   setsearch(name)
//   setPageNumber(1);
// }
// const handleChangeBUId = (event) => {
// setbuid(event.currentTarget.value);
// setsearch(name)
// setPageNumber(1);
// }

// const handleChangeGroupId = (event) => {
//   setgroupid(event.currentTarget.value);
//   setsearch(name)
// setPageNumber(1);

// }
     const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        setPageNumber(1);
        setsearch(name)
      }
    };
  

  
     const handleOnClick =(id,status,edit) => {
      setvalues({status: status});

    // console.log(status);
    // console.log(status);
          setdata([]);
        const subdata = (devicelist.filter(x=> x._id ===id))
       // const psubdata = [...subdata];
        
        setheader("แก้ไขเครื่อง")
          setdata(subdata)
          setisOpen(true);
          setEdit(edit);
        
    }
     const handleTextchange = (event) => {
      setname(event.currentTarget.value)

     }
     const handleSearchClick = () => {
      setPageNumber(1);
      
       setsearch(name);

     }
     const handleCancleSubmit = () => {

        setisOpen(false);
     }

     const handleConfirmSubmit = () => {
     
     setlastupdate(new Date());
    setisOpen(false);
    
   }
   const scrollToTop = () => { 
    setPageNumber(1);
    setshowonscroll(false);
  }
const  handleDisablechange =() => {
  setdisable(!disable);
  setPageNumber(1);
}
    // console.log(sitelist)

const handleClick = (id) => {
 // console.log(id)
  setvalues({face_id: id});
  setisOpen(true);


  
}
//console.log(devicelist);

  return <>
<ModalAddItem
        isOpen={isOpen}
        button1="บันทึก"
        onCancel={handleCancleSubmit}
        onChange={handleTextchange} 
        onconfirm={handleConfirmSubmit}
        enable={true}
        value = {values}
        list ={data}
        header ="รายชื่ออุปกรณ์"      
        edit ={edit}
      />

<div className="container-fluid">
        <div className="row">         
          <div className="col-lg-4  col-sm-6 col-xs-12">
            <div className="form-group">
            <Input
                    name="devicename"
                    value={name}
                    label="อุปกรณ์"
                    placeholder="รหัส/ชื่อ เพื่อค้นหา"
                    onChange = {handleTextchange}
                    onClick = {handleSearchClick}
                    onKeyPress={handleKeyPress}
                    search="ค้นหา"
                  />
            </div>
          </div>
        
          
          {/* <div className="col-lg-4  col-sm-6 col-xs-12">
            <Select
              label="กลุ่มอุปกรณ์"
              data={grouplist}
              value={groupid}
              textProperty="name"
              valueProperty="_id"
              onChange={handleChangeGroupId}
            />
          </div> */}
          <Input
                    name="disable"
                    value={disable}
                    label="เฉพาะที่ยกเลิก"
                   type ="checkbox"
                    onChange = {handleDisablechange}                                         
                   checked={disable}
                    error=""                
                  />
          {/* <div className="col-lg-6  col-sm-10 col-xs-12">
            <div className="form-group">

           
              <i>
                พื้นที่ <span className="label label-default"></span>
              </i>
              <div className="mt-2" style={{ marginTop: 20, marginBottom: 20 }}>
                <Header onChange={handleChange} />
              </div>
           
        
         
            </div>
          </div> */}
         
        </div>
        {/* <Header onChange={handleChange} handleDateChange={handleDateChange} /> */}
      </div>
<div className="row">
<div className="col-auto mt-2" >
          <div className="container">
            <button
              className="btn btn-primary"
              onClick={() => handleOnClick(0, "new")}
            >
              <FontAwesome name="plus" />
              <i /> Add New
                          </button>
            <br />
            <br />
          
          </div>
        </div>
        <div className="col-auto mt-2" >
        <p className="text-success">
        แสดงข้อมูล {devicelist ? devicelist.length : 0}  /  {total} รายการ
      </p>
        </div>
        
      

</div>




     
      
        <ScrollToTop 
        onClick ={scrollToTop}
        />

   <Renderdevice
  list = {devicelist}
  handleOnClick = {handleOnClick}
 error={error}
 handleClick = {handleClick}
  lastBookElementRef={lastBookElementRef}
            />
  </>
};

export default Itemlist;
